function a(e, r) {
  for (var l = -1, n = e == null ? 0 : e.length, t = Array(n); ++l < n; )
    t[l] = r(e[l], l, e);
  return t;
}
var u = a;
export {
  u as default
};
//# sourceMappingURL=_arrayMap.js.map
